import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * The attendee app is mounted under two shapes:
 *   /e/:slug/*   — event-scoped (shareable per-event URL)
 *   /app/*       — legacy, resolves to the "current" event
 *
 * `useAppBase` returns the correct base prefix for the current location so
 * in-app links stay within the active event. Use `appPath` to build links.
 */
export function useAppBase(): string {
  const { pathname } = useLocation()
  return useMemo(() => {
    const m = pathname.match(/^\/e\/([^/]+)/)
    return m ? `/e/${m[1]}` : '/app'
  }, [pathname])
}

/** Join the app base with a sub-path (sub may start with or without a slash). */
export function appPath(base: string, sub = ''): string {
  if (!sub || sub === '/') return base
  return `${base}${sub.startsWith('/') ? '' : '/'}${sub}`
}
